export default "__VITE_ASSET__BxWA13Wz__"